const inscriptionColors: Record<number, string> = {
  1: "#e83800",
  2: "#dee0df",
  3: "#0c5ea4",
  4: "#e8de00",
  5: "#5b861e",
  6: "#000000",
  7: "#ff8a22",
  8: "#dbaaee",
  9: "#23a08e",
  10: "#9066ee",
  11: "#5b645f",
  12: "#24dc24",
  13: "#484030",
  14: "#a35e55",
  15: "#f8a235",
  16: "#08e397",
};

const lightColors = ["#dee0df", "#e8de00", "#24dc24", "#08e397", "#dbaaee"];

interface ColorResult {
  color: string;
  textColor: string;
}

export const getColors = (inscriptionNumber: number): ColorResult => {
  const color = inscriptionColors[inscriptionNumber] || "#ffffff";
  const textColor = lightColors.includes(color) ? "black" : "white";

  return {
    color,
    textColor
  };
};

export default inscriptionColors;